import { CardSection } from '@components/CardSection'
import Button from '@components/Button'
import { compose, withHandlers } from 'recompose'
import { ACTIVE_FORM_LOGIN, ACTIVE_FORM_SIGNUP } from 'header/constants'
import { authVisible } from 'header/actions'
import { sendAmplitudeEvent, useSendGTAGEvent } from 'analytics/utils'

const DEFAULT_TITLE = <T>booking.confirm.and.pay.info</T>

const LoginSignUpContainer = ({
    onClickLogin,
    onClickSignUp,
    userPending,
    title = DEFAULT_TITLE,
    analyticsFlowType,
}) => {
    const sendGTAGEvent = useSendGTAGEvent()

    const onLoginClick = () => {
        if (analyticsFlowType) {
            sendGTAGEvent('login_in_purchase_journey', { flow_type: analyticsFlowType })
            sendAmplitudeEvent('Login In purchase journey', {
                'Flow Type': analyticsFlowType,
            })
        }
        onClickLogin()
    }

    const onSignUpClick = () => {
        if (analyticsFlowType) {
            sendGTAGEvent('signup_in_purchase_journey', { flow_type: analyticsFlowType })
            sendAmplitudeEvent('Signup in purchase journey selected', { 'Flow Type': analyticsFlowType })
        }
        onClickSignUp()
    }

    return (
        <CardSection loading={userPending === true}>
            <p>{title}</p>
            <div className="row">
                <div className="col-xs-12 col-sm-3">
                    <Button block onClick={onLoginClick}>
                        <T>booking.btn.login</T>
                    </Button>
                </div>
                <div className="col-xs-12 col-sm-3">
                    <Button block onClick={onSignUpClick} btnStyle="outline">
                        <T>booking.btn.signup</T>
                    </Button>
                </div>
            </div>
        </CardSection>
    )
}

export default compose(
    connect(null, { authVisible }),
    withHandlers({
        onClickLogin:
            ({ authVisible }) =>
            () => {
                authVisible(ACTIVE_FORM_LOGIN)
            },
        onClickSignUp:
            ({ authVisible }) =>
            () => {
                authVisible(ACTIVE_FORM_SIGNUP)
            },
    })
)(LoginSignUpContainer)
